import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
    makeStyles
} from "@mui/styles";
import {
    Grid,
    TextField
} from '@mui/material';
import getLoggedInUser from "../../utils/getLoggedInUser";
import SettingsIcon from '@mui/icons-material/Settings';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import ArrowDropDownCircleIcon from '@mui/icons-material/ArrowDropDownCircle';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import axios from "axios";

const useStyles = makeStyles({
    header: {
        height: "74px",
        padding: "10px 15px",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        boxShadow: "0px 2px 4px 0px #D1D1D140",
    },
    headerRightSection: {
        display: "flex",
        alignItems: "flex-start"
    },
    settingsIcon: {
        height: "25px",
        cursor: "pointer",
        color: "#A5ACB5",
        marginLeft: "10px"
    },
    bottomSection: {
        padding: "15px 20px"
    },
    searchView: {
        position: "relative",
        borderRadius: "20px",
        boxShadow: "5px 5px 21px 4px #00000014"
    },
    favouritesSearch: {
        width: "calc(100% - 30px)"
    },
    searchIcon: {
        position: "absolute",
        zIndex: 1,
        left: "10px",
        top: "50%",
        transform: "translate(0%,-50%)",
        color: "#666666"
    },
    search: {
        '& .MuiOutlinedInput-root': {
            backgroundColor: "white",
            borderRadius: "20px",
            '& .MuiInputBase-input': {
                padding: 0,
                paddingLeft: "35px",
                paddingRight: "17px",
                paddingTop: "10px",
                paddingBottom: "10px",
                fontSize: "13px",
                border: "none"
            },
        },
    },
    contactHeader: {
        marginBottom: "15px"
    },
    title: {
        margin: 0
    },
    plusBtn: {
        borderRadius: "50%",
        background: "linear-gradient(180deg,#d92cc1,#4D72F8)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "20px",
        height: "20px",
        cursor: "pointer",
        marginLeft: "10px"
    },
    plusIcon: {
        color: "white",
        height: "17px !important"
    },
    contactsList: {
        marginTop: "10px",
        marginRight: "-20px",
        paddingBottom: "10px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        height: "360px",
        overflowY: "scroll"
    },
    contacts: {
        width: "100%"
    },
    favContacts: {
        height: "calc(100vh - 645px)",
        overflowY: "scroll",
        paddingBottom: "10px",
        marginLeft: "-20px",
        marginRight: "-20px",
        paddingLeft: "20px",
        paddingRight: "20px",
        width: "100%"
    },
    alphabetHeader: {
        color: "#BBB9B9",
        margin: "0px",
        fontWeight: "bold",
        fontSize: "13px",
        marginTop: "10px"
    },
    alphabet: {
        margin: "0",
        fontSize: "10px",
        color: "#377DEF"
    },
    contactBox: {
        marginTop: "10px",
        cursor: "pointer"
    },
    profile: {
        border: "1px solid",
        // borderImageSource: "linear-gradient(180deg, #d92cc1, #4D72F8)",
        borderRadius: "50%",
        width: "40px",
        height: "40px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginRight: "10px"
    },
    profileSymbol: {
        color: "#d92cc1",
        fontWeight: "bold"
    },
    username: {
        margin: 0,
        fontWeight: "500",
        fontSize: "14px"
    },
    contact: {
        margin: 0,
        marginTop: "3px",
        fontSize: "12px",
        color: "#9F9F9F"
    },
    alphabets: {
        textAlign: "center",
        paddingRight: "20px"
    },
    sectionHeader: {
        margin: "0px -20px 20px -20px",
        padding: "12px 20px",
        borderTop: "1px solid #D1D1D1",
        borderBottom: "1px solid #D1D1D1",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
    },
    downArrow: {
        color: "#666666"
    },
    logoutBtn: {
        border: "none",
        marginLeft: "10px",
        backgroundColor: "white"
    },
    logoutIcon: {
        cursor: "pointer",
        color: "#A5ACB5"
    },
});

const RightSidebar = ({
    dialCall,
    outboundNumber
}) => {
    const classes = useStyles();
    const navigate = useNavigate();

    const [alphabets, setAlphabets] = useState([
        "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"
    ]);

    const [favouriteContacts, setFavouriteContacts] = useState([]);

    useEffect(() => {
        fetchFavouriteContacts();
    }, []);

    const fetchFavouriteContacts = () => {
        axios
            .get(process.env.REACT_APP_API_URL + "/" + process.env.REACT_APP_API_VERSION + "/contacts/favourite", {
                headers: {
                    "Authorization": `Bearer ${localStorage.getItem("userToken")}`
                }
            })
            .then(response => {
                if (response.data) {
                    setFavouriteContacts(response.data.favouriteContacts);
                }
            })
            .catch(error => {
                console.log("favourite contacts error", error);
            });
    }

    const logoutBtnClicked = () => {
        localStorage.removeItem("userToken");
        navigate("/");
    }

    return (
        <>
            <Grid>
                <Grid className={classes.header}>
                    <button
                        onClick={() => dialCall(2, "6479577219", outboundNumber?.phoneNumber, "6479577219")}
                    >
                        DTMF
                    </button>
                    <Link
                        to={`https://callapi.efone.ca/v4/api/jssip/jssip_v1.php?sipUser=${getLoggedInUser()?.sipUsername}&test=4`}
                        target="_blank"
                    >
                        Video
                    </Link>
                    <Link
                        to={`https://callapi.efone.ca/v4/api/jssip/jssip.php?sipUser=${getLoggedInUser()?.sipUsername}&test=4`}
                        target="_blank"
                        style={{ marginLeft: "10px" }}
                    >
                        Troubleshoot
                    </Link>
                    <SettingsIcon
                        className={classes.settingsIcon}
                    />
                    <button
                        className={classes.logoutBtn}
                        onClick={logoutBtnClicked}
                    >
                        <ExitToAppIcon
                            className={classes.logoutIcon}
                        />
                    </button>
                </Grid>
                <Grid className={classes.bottomSection}>
                    <Grid container justifyContent="space-between" alignItems="center" className={classes.contactHeader}>
                        <h3 className={classes.title}>Contact</h3>
                        <Grid className={classes.plusBtn}>
                            <AddIcon className={classes.plusIcon} />
                        </Grid>
                    </Grid>
                    <Grid className={classes.searchView}>
                        <SearchIcon
                            className={classes.searchIcon}
                        />
                        <TextField
                            placeholder="Search Contact"
                            className={classes.search}
                            fullWidth
                        />
                    </Grid>
                    <Grid className={classes.contactsList}>
                        <Grid className={classes.contacts}>
                            <p className={classes.alphabetHeader}>A</p>
                            <Grid container alignItems="center" className={classes.contactBox}>
                                <Grid className={classes.profile}>
                                    <p className={classes.profileSymbol}>A</p>
                                </Grid>
                                <Grid>
                                    <p className={classes.username}>Alina</p>
                                    <p className={classes.contact}>0923456784521</p>
                                </Grid>
                            </Grid>
                            <Grid container alignItems="center" className={classes.contactBox}>
                                <Grid className={classes.profile}>
                                    <p className={classes.profileSymbol}>A</p>
                                </Grid>
                                <Grid>
                                    <p className={classes.username}>Alina</p>
                                    <p className={classes.contact}>0923456784521</p>
                                </Grid>
                            </Grid>
                            <p className={classes.alphabetHeader}>B</p>
                            <Grid container alignItems="center" className={classes.contactBox}>
                                <Grid className={classes.profile}>
                                    <p className={classes.profileSymbol}>B</p>
                                </Grid>
                                <Grid>
                                    <p className={classes.username}>Brown</p>
                                    <p className={classes.contact}>0923456784521</p>
                                </Grid>
                            </Grid>
                            <Grid container alignItems="center" className={classes.contactBox}>
                                <Grid className={classes.profile}>
                                    <p className={classes.profileSymbol}>B</p>
                                </Grid>
                                <Grid>
                                    <p className={classes.username}>Ben</p>
                                    <p className={classes.contact}>0923456784521</p>
                                </Grid>
                            </Grid>
                            <p className={classes.alphabetHeader}>B</p>
                            <Grid container alignItems="center" className={classes.contactBox}>
                                <Grid className={classes.profile}>
                                    <p className={classes.profileSymbol}>B</p>
                                </Grid>
                                <Grid>
                                    <p className={classes.username}>Brown</p>
                                    <p className={classes.contact}>0923456784521</p>
                                </Grid>
                            </Grid>
                            <Grid container alignItems="center" className={classes.contactBox}>
                                <Grid className={classes.profile}>
                                    <p className={classes.profileSymbol}>B</p>
                                </Grid>
                                <Grid>
                                    <p className={classes.username}>Ben</p>
                                    <p className={classes.contact}>0923456784521</p>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid className={classes.alphabets}>
                            {
                                alphabets?.map((alphabet, key) => {
                                    return (
                                        <p className={classes.alphabet}>{alphabet}</p>
                                    )
                                })
                            }
                        </Grid>
                    </Grid>
                    <Grid>
                        <Grid className={classes.sectionHeader}>
                            <h3 className={classes.title}>Favourites</h3>
                            <ArrowDropDownCircleIcon
                                className={classes.downArrow}
                            />
                        </Grid>
                        <Grid container alignItems="center">
                            <Grid className={[classes.searchView, classes.favouritesSearch]}>
                                <SearchIcon
                                    className={classes.searchIcon}
                                />
                                <TextField
                                    placeholder="Search Favourites"
                                    className={classes.search}
                                    fullWidth
                                />
                            </Grid>
                            <Grid className={classes.plusBtn}>
                                <AddIcon className={classes.plusIcon} />
                            </Grid>
                        </Grid>
                        <Grid className={[classes.contacts, classes.favContacts]}>
                            {/* <p className={classes.alphabetHeader}>A</p> */}
                            {
                                favouriteContacts?.map(contact => {
                                    return (
                                        <Grid
                                            container
                                            alignItems="center"
                                            className={classes.contactBox}
                                        >
                                            <Grid className={classes.profile}>
                                                <p className={classes.profileSymbol}>{contact.fullName[0]}</p>
                                            </Grid>
                                            <Grid>
                                                <p className={classes.username}>{contact.fullName}</p>
                                                <p className={classes.contact}>{contact.contactNumber}</p>
                                            </Grid>
                                            <button
                                                style={{ marginLeft: "auto" }}
                                                onClick={() => dialCall(1, contact.contactNumber, outboundNumber?.phoneNumber, contact.fullName)}>
                                                eFone Call
                                            </button>
                                            <button
                                                onClick={() => dialCall(2, contact.contactNumber, outboundNumber?.phoneNumber, contact.fullName)}>
                                                Call
                                            </button>
                                        </Grid>
                                    )
                                })
                            }
                            {/* <Grid container alignItems="center" className={classes.contactBox}>
                                <Grid className={classes.profile}>
                                    <p className={classes.profileSymbol}>A</p>
                                </Grid>
                                <Grid>
                                    <p className={classes.username}>Alina</p>
                                    <p className={classes.contact}>0923456784521</p>
                                </Grid>
                            </Grid>
                            <p className={classes.alphabetHeader}>B</p>
                            <Grid container alignItems="center" className={classes.contactBox}>
                                <Grid className={classes.profile}>
                                    <p className={classes.profileSymbol}>B</p>
                                </Grid>
                                <Grid>
                                    <p className={classes.username}>Brown</p>
                                    <p className={classes.contact}>0923456784521</p>
                                </Grid>
                            </Grid>
                            <Grid container alignItems="center" className={classes.contactBox}>
                                <Grid className={classes.profile}>
                                    <p className={classes.profileSymbol}>B</p>
                                </Grid>
                                <Grid>
                                    <p className={classes.username}>Ben</p>
                                    <p className={classes.contact}>0923456784521</p>
                                </Grid>
                            </Grid>
                            <p className={classes.alphabetHeader}>B</p>
                            <Grid container alignItems="center" className={classes.contactBox}>
                                <Grid className={classes.profile}>
                                    <p className={classes.profileSymbol}>B</p>
                                </Grid>
                                <Grid>
                                    <p className={classes.username}>Brown</p>
                                    <p className={classes.contact}>0923456784521</p>
                                </Grid>
                            </Grid>
                            <Grid container alignItems="center" className={classes.contactBox}>
                                <Grid className={classes.profile}>
                                    <p className={classes.profileSymbol}>B</p>
                                </Grid>
                                <Grid>
                                    <p className={classes.username}>Ben</p>
                                    <p className={classes.contact}>0923456784521</p>
                                </Grid>
                            </Grid> */}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

        </>
    )
}

export default RightSidebar;